import { makeStyles } from '@material-ui/core/styles';

const titleButton = {
  padding: '3px',
  fontSize: '0.7rem',
  lineHeight: '1.5',
  fontWeight: 600,
};
const buttonHighlight = '#FFA500';
export const useStyles = makeStyles((theme) => ({
  printTitle: {
    fontWeight: 600,
    '@media print': {
      '&&': {
        color: 'black',
        fontWeight: 600,
      },
    },
  },
  readLabel: {
    padding: '2px',
    color: `${(theme as any).palette.form.primary.main}`,
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  fieldLabel: {
    padding: '2px',
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  requiredFieldLabel: {
    padding: '2px',
    color: `${(theme as any).palette.error.main}`,
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  statementTitle: {
    margin: '10px',
    padding: '2px',
    fontSize: '1.4rem',
    fontWeight: 'bold',
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  statementReadTitle: {
    padding: '2px',
    fontSize: '1.4rem',
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  statementField: {
    padding: '2px',
    fontSize: '1rem',
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  defaultColor: {
    color: `${(theme as any).palette.form.text.notes}`,
    padding: '5px',
    '&.Mui-checked': {
      color: `${(theme as any).palette.form.text.secondary}`,
    },
  },
  label: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px',
  },
  requiredLabel: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px',
    color: `${(theme as any).palette.error.main}`,
  },
  readOnlyLabel: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px',
    '&&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default',
    },
  },
  dateLabel: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px',
    transform: 'translate(10px, -2px) scale(0.75)',
  },
  // @note nay be needed
  // required: {
  //   color: `${(theme as any).palette.error.main}`,
  //   padding: '5px',
  // },
  // requiredLabel: {
  //   fontSize: '1.14rem',
  //   flexWrap: 'nowrap',
  //   minWidth: '55px',
  //   color: `${(theme as any).palette.error.main}`,
  // },
  buttonRoot: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
    marginTop: '14px',
    marginRight: '10px',
  },
  labelRoot: {
    marginBottom: '0px',
  },
  readOnlyLabelRoot: {
    marginBottom: '0px',
    '&&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default',
    },
  },
  // top buttons #85bffd
  regularButton: {
    backgroundColor: `${(theme as any).palette.form.activeButton}`,
    color: 'white',
    border: `1px solid ${(theme as any).palette.form.activeButton}`,
    ...titleButton,
    '&&:hover': {
      backgroundColor: `${(theme as any).palette.form.hoverButton}`,
      color: `white`,
      border: `1px solid ${(theme as any).palette.form.activeButton}`,
    },
    '&&:focus': {
      outline: 0,
    },
  },
  buttonHide: {
    display: 'none',
  },
  selectedButton: {
    backgroundColor: `${(theme as any).palette.form.activeButton}`,
    color: 'white',
    border: `4px solid ${buttonHighlight}`,
    boxShadow: `0 0 1px 1px ${buttonHighlight}`,
    ...titleButton,
    '&&:hover': {
      backgroundColor: `${(theme as any).palette.form.activeButton}`,
      color: 'white',
      border: `4px solid ${buttonHighlight}`,
    },
    '&&:focus': {
      outline: 0,
    },
  },
  selectedRequiredButton: {
    backgroundColor: `${(theme as any).palette.form.activeButton}`,
    color: 'white',
    border: `4px solid ${buttonHighlight}`,
    boxShadow: `0 0 1px 1px ${buttonHighlight}`,
    borderLeft: `10px solid ${(theme as any).palette.error.main}`,
    ...titleButton,
    '&&:hover': {
      backgroundColor: `${(theme as any).palette.form.activeButton}`,
      color: 'white',
      border: `4px solid ${buttonHighlight}`,
      borderLeft: `10px solid ${(theme as any).palette.error.main}`,
    },
    '&&:focus': {
      outline: 0,
    },
  },
  requiredButton: {
    backgroundColor: `${(theme as any).palette.form.activeButton}`,
    color: 'white',
    border: `1px solid ${(theme as any).palette.form.activeButton}`,
    borderLeft: `10px solid ${(theme as any).palette.error.main}`,
    ...titleButton,
    '&&:hover': {
      backgroundColor: `${(theme as any).palette.form.hoverButton}`,
      border: `1px solid ${(theme as any).palette.form.activeButton}`,
      borderLeft: `10px solid ${(theme as any).palette.error.main}`,
    },
    '&&:focus': {
      outline: 0,
    },
  },
  successButton: {
    backgroundColor: `${(theme as any).palette.success.main}`,
    color: `white`,
    border: `1px solid ${(theme as any).palette.success.main}`,
    ...titleButton,
    '&&:hover': {
      backgroundColor: `${(theme as any).palette.success.main}`,
      border: `1px solid ${(theme as any).palette.success.main}`,
      color: `white`,
      '&&:focus': {
        outline: 0,
      },
    },
  },
  successRequiredButton: {
    backgroundColor: `${(theme as any).palette.success.main}`,
    color: `white`,
    border: `1px solid ${(theme as any).palette.success.main}`,
    borderLeft: `10px solid ${(theme as any).palette.error.main}`,
    ...titleButton,
    '&&:hover': {
      border: `1px solid ${(theme as any).palette.form.activeButton}`,
      borderLeft: `10px solid ${(theme as any).palette.error.main}`,
      backgroundColor: `${(theme as any).palette.success.main}`,
      color: `white`,
    },
    '&&:focus': {
      outline: 0,
    },
  },
  radioButtonRoot: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
    marginTop: '12px',
    marginRight: '10px',
  },
  buttonLabel: {
    fontSize: '0.8rem',
  },
  buttonOutlined: {
    padding: '1px',
  },
  readOnly: {
    color: `${(theme as any).palette.form.text.notes}`,
    '&&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default',
    },
    '&.Mui-checked': {
      color: `${(theme as any).palette.form.text.secondary}`,
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  helperText: {
    color: `${(theme as any).palette.form.primary.main}`,
    margin: 0,
    marginLeft: 30,
  },
  chipRoot: {
    backgroundColor: `${(theme as any).palette.error.main}`,
    color: `${(theme as any).palette.common.white}`,
    height: `18px`,
  },
  inputTextField: {
    width: '100%',
    fontSize: '1rem',
    color: `${(theme as any).palette.form.primary.main} !important`,
  },
  addendumTextField: {
    width: '100%',
    fontSize: '1rem',
    fontFamily:
      'Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace',
    color: `${(theme as any).palette.form.text.secondary}`,
    '&&.Mui-disabled': {
      color: `${(theme as any).palette.form.text.secondary}`,
    },
  },
  inputLabel: {
    color: `${(theme as any).palette.form.primary.main}`,
    '&.Mui-focused': {
      color: `${(theme as any).palette.form.text.secondary}`,
    },
    '&&.Mui-disabled': {
      color: `${(theme as any).palette.form.primary.main}`,
    },
  },
  requiredInputLabel: {
    color: `${(theme as any).palette.error.main}`,
    '&.Mui-focused': {
      color: `${(theme as any).palette.form.text.secondary}`,
    },
    '&&.Mui-disabled': {
      color: `${(theme as any).palette.form.primary.main}`,
    },
  },
  requiredButtonBadge: {
    color: `${(theme as any).palette.error.main}`,
  },
}));
